/**
 * Custom replacer for JSON.stringify to handle BigInt values
 * Converts BigInt to string representation
 */
export const bigIntReplacer = (key: string, value: any) => {
  if (typeof value === 'bigint') {
    return value.toString();
  }
  return value;
};

/**
 * Safely stringify objects containing BigInt values
 */
export const stringifyWithBigInt = (obj: any): string => {
  return JSON.stringify(obj, bigIntReplacer);
};

